import Http from '../../http';
import HttpV2 from '../../httpv2';
import {
  REGISTER_FETCH_SUMMARY,
  REGISTER_REFUND_SALE,
  REGISTER_REFUND_CUSTOM_CHARGE,
  REGISTER_REFUND_RECURRING_MEMBERSHIP,
  REGISTER_FETCH_SUMMARY_START,
  REGISTER_REASSIGN_SALE,
  SET_REFUND_DATA,
} from './constants';
import { formatDateForShop } from '../../common/helpers/times';
import { downloadCsv } from '../../main/reports/helpers';
import { stripeConnectTokenAction } from '../../terminal/actions';
import { updateInvoiceStatus } from '../../memberships/invoices/actions';

const fetchSummaryAction = payload => ({
  type: REGISTER_FETCH_SUMMARY,
  payload,
});

const fetchSummaryStart = () => ({
  type: REGISTER_FETCH_SUMMARY_START,
});

export const downloadSummary = (ownerId, ownerType, reportName, from, to) => {
  const endpoint = `/${ownerType}/${ownerId}/daily-summary/transactions/${from}/${to}`;

  return HttpV2
    .getRaw(endpoint, { view: 'csv' })
    .then(response =>
      downloadCsv(
        response,
        `${reportName} - Daily summary report ${formatDateForShop(from)} to ${formatDateForShop(to)}`
      )
    );
};


export const getSummaryRequest = (ownerId, ownerType, from, to, barberIds) => {
  const barberIdsFilter = barberIds ? `&barberId__in=${barberIds.join(',')}` : '';

  return HttpV2
    .get(`/${ownerType}/${ownerId}/daily-summary/transactions/${from}/${to}?with=numberOfTickets${barberIdsFilter}`);
};

export const fetchSummary = (ownerId, ownerType, from, to, barberIds) =>
  (dispatch) => {
    dispatch(fetchSummaryStart());

    return getSummaryRequest(ownerId, ownerType, from, to, barberIds)
      .then(data => dispatch(fetchSummaryAction(data)));
  };

const refundSaleAction = payload => ({
  type: REGISTER_REFUND_SALE,
  payload,
});

export const refundOwnerSale = (ownerId, ownerType, saleId, refundOptions) => dispatch => (
  Http.post(`/${ownerType}/${ownerId}/sale/${saleId}/refund`, refundOptions)
    .then(data => dispatch(refundSaleAction(data)))
);

export const refundSale = (shopId, saleId, refundOptions) => refundOwnerSale(shopId, 'shop', saleId, refundOptions);

export const refundOwnerSaleItem = (ownerId, ownerType, saleId, item) => dispatch =>
  Http.post(`/${ownerType}/${ownerId}/sale/${saleId}/refund`, { item }).then(data => dispatch(refundSaleAction(data)));

export const refundSaleItem = (shopId, saleId, item) => refundOwnerSaleItem(shopId, 'shop', saleId, item);

export const refundCustomChargeAction = payload => ({
  type: REGISTER_REFUND_CUSTOM_CHARGE,
  payload,
});

export const refundOwnerCustomCharge = (ownerId, ownerType, chargeId) => dispatch =>
  Http.post(`/${ownerType}/${ownerId}/charge/${chargeId}/refund`, {})
    .then(data => dispatch(refundCustomChargeAction(data)));

export const refundCustomCharge = (shopId, chargeId) => refundOwnerCustomCharge(shopId, 'shop', chargeId);

export const setRefundData = (shop, sale, options, callback) => ({
  type: SET_REFUND_DATA,
  payload: { shop, sale, options },
  callback,
});

export const refundInteracCharge = (shop, sale, options, callback) => (dispatch) => {
  dispatch(stripeConnectTokenAction('refund'));
  dispatch(setRefundData(shop, sale, options, callback));
  return Promise.resolve('interac_present');
};

const reassignAction = payload => ({
  type: REGISTER_REASSIGN_SALE,
  payload,
});

export const reassignSaleItem = (shopId, itemId, parentId, barber) => dispatch =>
  Http.post(`/shop/${shopId}/daily-summary/${itemId}/reassign`, {
    barberId: barber.id,
    saleOrderId: parentId,
  }).then(() => dispatch(reassignAction({ id: itemId, parentId, barber })));

const refundRecurringMembershipAction = payload => ({
  type: REGISTER_REFUND_RECURRING_MEMBERSHIP,
  payload,
});

export const refundRecurringMembership = (ownerType, ownerId, subscriptionId, invoiceId) => dispatch =>
  updateInvoiceStatus(ownerType, ownerId, subscriptionId, invoiceId, 'refund')
    .then(response => dispatch(refundRecurringMembershipAction({ id: response.id })));
